<template>
    <div class="wrapper">
      <section class="side">
        <p class="main-msg">{{ $t('slogan1') }} {{ $t('slogan2') }}</p>
        <p class="secondary-msg">
      {{ $t('statement1') }} {{ $t('statement2') }}</p>
        <router-link :to="'/' + $i18n.locale"><img src="../assets/static/images/expar_logo_white.png" alt="expar logo"></router-link>
      </section>

      <section class="main">
        <p class="title">{{ $t('registration') }}</p>
        <div class="separator"></div>
        <router-link v-if="!isChckoutRegister" class="close" :to="'/' + $i18n.locale"> ></router-link>
        <p class="welcome-message">{{ $t('signupMsg') }}</p>

        <form @submit.prevent="register">
          <div class="form-control">
            <input 
              v-model="firstName" 
              type="text" 
              name="firstName" 
              :placeholder="$t('name')"
              value>
            <i class="fas fa-user"></i>
          </div>
          <div class="form-control">
            <input 
              v-model="lastName" 
              type="text" 
              name="lastName" 
              :placeholder="$t('surname')"
              value>
            <i class="fas fa-user"></i>
          </div>
          <div class="form-control">
            <input 
              v-model="email" 
              type="email" 
              name="email" 
              :placeholder="$t('email')"
              value v-on="$listeners" 
              @blur="$v.email.$touch()" 
              v-on:input="errors = null"
              :class="{ 'error-boarder': $v.email.$error }" >
            <i class="fas fa-envelope"></i>
          </div>
          <div class="form-control">
            <input 
              v-model="password" 
              :class="{ 'error-boarder': $v.password.$error }" 
              type="password*" 
              name="password" 
              :placeholder="$t('password')"
              @blur="$v.password.$touch()"
              v-on="$listeners" 
              value >
            <i class="fas fa-lock"></i>
          </div>

          <template v-if="$v.email.$error">
            <div v-if="!$v.email.email" class="errorMessage">{{ $t('emailValid') }}</div>
            <div v-if="!$v.email.required" class="errorMessage">{{ $t('emailReq') }}</div>
          </template>
          <template v-if="$v.password.$error">
            <div v-if="!$v.password.required" class="errorMessage">{{ $t('passReq') }}</div>
          </template>


          <button :disabled="$v.$invalid" class="action" type="submit" name="button">{{ $t('signup') }}</button>

          <!-- <div v-if="this.errors" class="errorMessage">
            {{ this.errors }}
          </div> -->

        </form>

        <div class="login">
          <p>{{ $t('haveAccount') }}</p>
          <button @click="redirectLogin">{{ $t('login') }}</button>
        </div>
      </section>
    </div>
</template>


<script>

import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      role: 'user',
      errors: null,
  	  error: false,
      type: "signUp"
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  methods: {
    register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        console.log("form submitted:", this.email);
      }
      this.$store
        .dispatch('register', {
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          role: this.role
        })
        .then(() => {
			if(this.isChckoutRegister) {
				this.$emit('register-response', {})
			} else {
          		this.$router.push({ name: 'login' }) // automatically redirect to login when user click "register"//
			}
        })
        .catch(err => {
          this.errors = err.response.data.message
          this.$refs.modalError.open()
        })
      this.$v.$touch();
      if (!this.$v.$invalid) {
        console.log("form submitted:", this.email);
      }
	},
	redirectLogin() {
      if(this.isChckoutRegister) {
        this.$emit('login-redirect', true)
      } else {
        this.$router.push({ name: 'login', params: { lang:  this.$i18n.locale} }) 
      }
    }
  },
  props: {
	  isChckoutRegister: {
		  type: Boolean,
		  default: false
	  }
  }
}
</script>

<style lang="css" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.wrapper {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 60% 1fr;
    color: #696969;
}

section {
    display        : flex;
    flex-direction : column;
    justify-content: center;
    align-items    : center;
    padding        : 48px;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}
.error-boarder {
  border: 2px solid var(--primaryDark);
}

.side {
  	background: linear-gradient(16deg, rgba(76,158,134,1) 0%, rgba(61,113,109,1) 8%, rgba(47,71,85,1) 38%, rgba(44,62,80,1) 47%, rgba(44,62,80,1) 50%, rgba(44,62,80,1) 80%);  /* background: url("../assets/static/images/background.png")no-repeat; */
	height: 100%;
}

.side img {
    width    : 30%;
}

.side p {
    max-width     : 500px;
    color         : #ddfdff;
    letter-spacing: 1px;
    line-height   : 1.8em;
    margin-bottom : 40px;
}

.side .main-msg {
    color        : rgb(96, 204, 172);
    font-size    : 3.2em;
    font-weight  : bold;
    line-height  : 1.5em;
    margin-bottom: 20px;
}

.title {
    font-size     : 3em !important;
    font-weight   : bold;
    text-align    : center;
    letter-spacing: 1px;
    color: var(--bg);
}

.separator {
    width           : 150px;
    height          : 4px;
    background-color: var(--primary);
    margin          : 24px;
}

.welcome-message {
    text-align   : center;
    font-size    : 1.1em;
    line-height  : 28px;
    margin-bottom: 10px;
}

.close {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

form {
    width         : 100%;
    max-width: 400px;
    display       : flex;
    flex-direction: column;
}

.form-control {
    width        : 100%;
    position     : relative;
    margin-bottom: 24px;
    border: none !important;
}

input,
button {
    border       : none;
    outline      : none;
    border-radius: 30px;
    font-size    : 1.1em;
}

input {
    width         : 100%;
    background    : #e6e6e6;
    color         : #333;
    letter-spacing: 0.5px;
    padding       : 14px 64px;
}

input~i {
    position  : absolute;
    left      : 22px;
    top       : 80%;
    transform : translateY(-50%);
    color     : var(--gray);
    transition: color 0.4s;
    font-size: 1.3em;
}

input:focus~i {
    color: #0E484B;
}

button.action {
    color           : #fff;
    padding         : 14px 64px;
    margin          : 32px auto;
    text-transform  : uppercase;
    letter-spacing  : 2px;
    font-weight     : bold;
    background-color: var(--primary);
    background: var(--primary);
    cursor          : pointer;
    transition      : opacity 0.4s;
}

button.action:hover {
    opacity: 0.9;
}

.login {
    position       : absolute;
    bottom         : 32px;
    display        : flex;
    justify-content: center;
    align-items    : center;
}

.login button {
    margin-left  : 16px;
    background   : none;
    color: var(--bg);
    border-bottom: 2px solid var(--bg);
    border-radius: 0;
    padding      : 4px;
    cursor       : pointer;
    font-weight  : bold;
}

.login button:hover {
    color: var(--primary);
    border-bottom: 2px solid var(--primary);
}


.login p {
  margin-bottom: 0;
}

/* ----  Responsiveness   ----  */
@media (max-width: 480px) {
.section {
  padding: 48px 20px 60px 20px !important;;
}
.login {
  bottom: 5px;
}
}

@media (max-width: 780px) {
    .wrapper {
        grid-template-columns: 1fr;
    }

    .side {
        display: none;
    }
}

@media (min-width: 775px) {
.close {
  display: none;
}
}

</style>